import AuthForm from "@/components/auth/AuthForm";

const Index = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background dark:bg-gray-900 p-4">
      <div className="text-center mb-8">
        <h1 className="text-4xl font-bold text-foreground dark:text-white mb-2 text-center">LevAI</h1>
        <p className="text-lg text-muted-foreground dark:text-gray-300">Track and analyze your health data</p>
      </div>
      
      <AuthForm />
      
    </div>
  );
};

export default Index;
